var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagination-state" }, [
    _c(
      "p",
      [
        _vm.pagination.page_count > 1
          ? [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.productsCount[0]) +
                    " - " +
                    _vm._s(_vm.productsCount[1])
                )
              ]),
              _vm._v(" z\n        ")
            ]
          : _vm._e(),
        _vm._v(
          "\n        " +
            _vm._s(_vm.pagination.product_found) +
            " produktów\n    "
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }